import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './FeaturesCheck.module.scss'

/** @type {import("./types").default} */
const FeatureCheck = ({ children, checked, className, ...props }) => {
  return (
    <div {...props} className={clsx('FeatureCheck', classes.root, className, { [classes.checked]: checked })}>
      <div className={classes.content}>{children}</div>
      <Icon className={classes.icon} icon={checked ? 'check' : 'times'} prefix="fas" />
    </div>
  )
}

export default FeatureCheck
